import React, { Component } from 'react';
import { Navbar, Nav, NavItem, Glyphicon, Badge } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';
import Api from '../../Global/Modules/Api'

class AccountMenu extends Component {
    constructor() {
        super();
        this.state = {
            member: []
        }
    }
    componentWillMount() {
        var url = "api/members/report";
        Api.GetApi(url).then(data => {
            this.setState({ member: data.member })
        });
    }
    render() {
        return (
            <Navbar fluid collapseOnSelect bsStyle="default" className="AccountMenu">
                <Navbar.Header className="">
                    <Navbar.Brand className="visible-xs">
                        Mijn CR
                    </Navbar.Brand>
                    <Navbar.Toggle>
                        <Glyphicon glyph="menu-hamburger" />
                    </Navbar.Toggle>
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer exact to="/account/mijn-cr">
                            <NavItem eventKey={2}>
                                <Badge>
                                    <Glyphicon glyph="home" />
                                </Badge> Mijn CR
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/account/beheren">
                            <NavItem eventKey={2}>
                                <Badge>
                                    <Glyphicon glyph="user" />
                                </Badge> Account
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/kennis/beheren">
                            <NavItem eventKey={3}>
                                <Badge>
                                    <Glyphicon glyph="education" />
                                </Badge>  {this.state.member.status == 'Aspirant' || this.state.member.status == 'Nonactief' ? 'Kennis' : 'Permanente educatie'}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/werkervaring/beheren">
                            <NavItem eventKey={4}>
                                <Badge>
                                    <Glyphicon glyph="briefcase" />
                                </Badge> {this.state.member.status == 'Aspirant' || this.state.member.status == 'Nonactief' ? 'Werkervaring' : 'Doorlopende werkervaring'}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/rapport/bekijken">
                            <NavItem eventKey={5}>
                                <Badge>
                                    <Glyphicon glyph="signal" />
                                </Badge> Rapport
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/account/indienen">
                            <NavItem eventKey={6}>
                                <Badge>
                                    <Glyphicon glyph="download-alt" />
                                </Badge> Aanvraag indienen
                            </NavItem>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default AccountMenu;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/AccountMenu.js